import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const TESTIMONIALS = [
  {
    text: 'O Dr. Patrick foi fundamental no momento mais difícil da minha vida. Sua presença na audiência de custódia e o acompanhamento em todas as etapas me deram segurança e confiança.',
    author: 'Cliente Anônimo',
    detail: 'Audiência de Custódia',
  },
  {
    text: 'Profissionalismo e humanidade em cada atendimento. O acompanhamento na delegacia e a estratégia de defesa foram impecáveis. Recomendo sem hesitar.',
    author: 'Família de Cliente',
    detail: 'Acompanhamento em Flagrante',
  },
  {
    text: 'Patrick conduziu meu caso com extrema competência técnica e sensibilidade. Sempre transparente, sempre presente. Resultado além do esperado.',
    author: 'Cliente Anônimo',
    detail: 'Defesa em Tribunal do Júri',
  },
];

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-white py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="font-montserrat text-grey text-xs tracking-widest uppercase">
            Depoimentos
          </span>
          <h2 className="font-cinzel font-bold text-navy text-2xl md:text-4xl lg:text-5xl mt-3 leading-tight">
            O que dizem sobre o atendimento
          </h2>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className={`bg-bg-light rounded-2xl md:rounded-3xl p-6 md:p-8 transition-all duration-500 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center mb-5">
                <i className="ri-double-quotes-l text-white text-lg w-full h-full flex items-center justify-center" />
              </div>
              <p className="font-montserrat font-light text-grey text-sm md:text-base leading-relaxed">
                "{t.text}"
              </p>
              <div className="mt-6 pt-4 border-t border-gray-200">
                <p className="font-montserrat font-semibold text-navy text-sm">
                  {t.author}
                </p>
                <p className="font-montserrat font-light text-grey-light text-xs mt-0.5">
                  {t.detail}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile carousel dots */}
        <div className="flex md:hidden justify-center gap-2 mt-6">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(i)}
              className={`w-2 h-2 rounded-full transition-colors ${
                activeIndex === i ? 'bg-navy' : 'bg-gray-300'
              }`}
              aria-label={`Depoimento ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}